module.exports = __webpack_public_path__ + "img/leftWhite.98912f7e.svg";